import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WhatsappService } from '../../shared/services/whatsapp.service';
import { EvolutionInstanceService } from '../../shared/services/evolution-instance.service';
import { AppConfirmService } from '../../shared/services/app-confirm/app-confirm.service';
import { HttpEventType } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { warn } from 'console';
import { WhatsAppConfigService } from '../utilitario/whatsapp-config/whatsapp-config.service';
import { JwtAuthService } from '../../shared/services/auth/jwt-auth.service';
import { AppLoaderService } from '../../shared/services/app-loader/app-loader.service';

@Component({
  selector: 'app-whatsapp-edit',
  templateUrl: './whatsapp-edit.component.html',
  styleUrls: ['./whatsapp-edit.component.css']
})
export class WhatsappEditComponent implements OnInit {
  form: FormGroup;
  attachments: File[] = [];
  sending = false;
  instanceName: string | null = null;

  constructor(
    private fb: FormBuilder,
    private whatsappConfigService: WhatsAppConfigService,
    private confirmService: AppConfirmService,
    private jwtAuth: JwtAuthService,
    private whatsappService: WhatsappService,
    private loader: AppLoaderService,
    public dialogRef: MatDialogRef<WhatsappEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const toValidators = (data && data.to) ? [] : [Validators.required];
    this.form = this.fb.group({
      to: ['', toValidators],
      message: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // preencher valores iniciais passados via MAT_DIALOG_DATA
    try {
      if (this.data) {
        if (this.data.to) {
          this.form.controls['to'].setValue(this.data.to);
        }
        if (this.data.message) {
          this.form.controls['message'].setValue(this.data.message);
        }
        // aceitar arquivos passados como Blobs ou Files
        if (this.data.files && Array.isArray(this.data.files) && this.data.files.length > 0) {
          this.data.files.forEach((f: any, idx: number) => {
            if (f instanceof File) {
              this.attachments.push(f);
            } else if (f instanceof Blob) {
              const name = (f as any).name || (`attachment-${idx + 1}.pdf`);
              this.attachments.push(new File([f], name, { type: (f as any).type || 'application/pdf' }));
            } else if (f && f.blob && f.name) {
              this.attachments.push(new File([f.blob], f.name, { type: f.blob.type || 'application/pdf' }));
            }
          });
        }
      }
    } catch (e) {
      console.warn('Erro ao popular dados iniciais do WhatsApp dialog', e);
    }
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;
    for (let i = 0; i < input.files.length; i++) {
      this.attachments.push(input.files.item(i) as File);
    }
    input.value = '';
  }

  removeAttachment(index: number) {
    this.attachments.splice(index, 1);
  }

  send() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

   

    let toRaw = this.form.value.to;
    // Suporta múltiplos números separados por ;
    let toList: string[] = [];
    let invalidNumbers: string[] = [];
    if (toRaw && typeof toRaw === 'string') {
      toList = toRaw.split(';').map(num => {
        let n = num.replace(/\D/g, '');
        if (n && !n.startsWith('55')) {
          n = '55' + n;
        }
        // Validação: DDD (2 dígitos) + 9 dígitos (celular) OU DDD + 8 dígitos (fixo)
        // Exemplo: 55 44 988881234 (celular), 55 44 32221234 (fixo)
        if (!/^55\d{2}(9\d{8}|[2-5]\d{7})$/.test(n)) {
          invalidNumbers.push(num.trim());
        }
        return n;
      }).filter(n => n.length > 0);
    }
    if (invalidNumbers.length > 0) {
      this.confirmService.confirm({
        title: 'Números inválidos',
        message: 'Os seguintes números estão com formato inválido (precisam ter DDD e 9 dígitos para celular ou 8 para fixo):\n' + invalidNumbers.join(', '),
        error: true,
        icon: 'warning',
        disableCancel: true
      });
      return;
    }
    const message = this.form.value.message;

    this.sending = true;

    const currentUser = this.jwtAuth.getUser();
    this.instanceName = currentUser?.username || null;

    console.log('Usuário atual:', JSON.stringify(currentUser));

    const username = currentUser?.usuario;

    console.log('Username obtido:', username);


    // Verifica instância Evolution antes de enviar (lógica robusta)
    this.whatsappConfigService.fetchInstance(username).subscribe({
      next: (instance: any) => {
        let found = false;
        const matchesUsername = (i: any, usernameToCheck: string) => {
          return (
            i == null ? false :
            i.name === usernameToCheck ||
            i.instanceName === usernameToCheck ||
            i.instance?.instanceName === usernameToCheck ||
            i.instance?.name === usernameToCheck
          );
        };

        if (Array.isArray(instance)) {
          found = instance.some(i => matchesUsername(i, username));
        } else if (instance && matchesUsername(instance, username)) {
          found = true;
        }

        let isConnected = false;
        if (found) {
          const findInst = Array.isArray(instance) ? instance.find(i => matchesUsername(i, username)) : instance;
          const instStatus = (findInst?.connectionStatus || findInst?.instance?.connectionStatus || findInst?.instance?.status || findInst?.status)?.toString().toLowerCase();
          if (instStatus === 'open' || instStatus === 'connected') {
            isConnected = true;
          }
        }

        if (!found || !isConnected) {
          this.loader.close();  
          this.sending = false;
          this.confirmService.confirm({
            title: 'Instância WhatsApp não conectada',
            message: 'Nenhuma instância WhatsApp conectada!\nConfigure uma instância em Utilitários > Configuração WhatsApp antes de enviar mensagens.',
            error: true,
            icon: 'warning',
            disableCancel: true
          });
          return;
        }

        console.log('Instância WhatsApp Evolution conectada. Enviando mensagem...');

        this.loader.open('Enviando...');

        // Preparar envio
        const total = toList.length;
        if (total === 0) {
          this.loader.close();  
          this.sending = false;
          this.confirmService.confirm({
            title: 'Nenhum número informado',
            message: 'Informe ao menos um número para envio.',
            error: true,
            icon: 'warning',
            disableCancel: true
          });
          return;
        }

        let done = 0;
        const successes: any[] = [];
        const errors: any[] = [];

        const finalize = () => {
          this.loader.close();  
          this.sending = false;
          if (errors.length === 0) {
            this.form.reset();
            this.attachments = [];
            this.confirmService.confirm({
              title: 'Mensagens enviadas',
              message: 'Todas as mensagens foram enviadas com sucesso.',
              icon: 'check_circle',
              disableCancel: true
            });
            this.dialogRef.close({ success: true });
          } else {
            // Mantém o diálogo aberto para correção; mostra resumo de erros
            this.confirmService.confirm({
              title: 'Envio concluído com erros',
              message: `Enviadas: ${successes.length} / ${total}. Erros: ${errors.length}. Verifique os detalhes no console.`,
              error: true,
              icon: 'warning',
              disableCancel: true
            });
            console.error('Erros no envio:', errors);
          }
        };

        // Função utilitária para determinar mediatype
        const detectMediaType = () => {
          if (this.attachments.length === 0) return undefined;
          const mime = this.attachments[0].type || '';
          if (mime.startsWith('image/')) return 'image';
          if (mime.startsWith('video/')) return 'video';
          if (mime.startsWith('audio/')) return 'audio';
          return 'document';
        };

        // Converter arquivos para base64 (uma vez) se houver anexo
        const filesToBase64Once = (): Promise<string[]> => {
          if (this.attachments.length === 0) return Promise.resolve([]);
          return Promise.all(this.attachments.map(file => {
            return new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => {
                const result = reader.result as string;
                const base64 = result.split(',')[1] || result;
                resolve(base64);
              };
              reader.onerror = reject;
              reader.readAsDataURL(file);
            });
          }));
        };

        filesToBase64Once().then((filesBase64) => {
          const filenames = this.attachments.map(f => f.name);
          const mediatype = detectMediaType();

          toList.forEach(number => {
            if (this.attachments.length > 0) {
              const payload: any = {
                number,
                caption: message,
                files: filesBase64,
                filenames,
                mediatype
              };
              this.whatsappService.sendMedia(username, payload).subscribe({
                next: (res: any) => {
                  // Sucesso no envio da mídia (legenda enviada em `caption`)
                  successes.push({ number });
                  done++;
                  if (done === total) finalize();
                },
                error: (err: any) => {
                  errors.push({ number, step: 'sendMedia', error: err });
                  done++;
                  if (done === total) finalize();
                }
              });
            } else {
              this.whatsappService.sendText(username, number, message).subscribe({
                next: () => {
                  successes.push({ number });
                  done++;
                  if (done === total) finalize();
                },
                error: (err: any) => {
                  errors.push({ number, step: 'sendText', error: err });
                  done++;
                  if (done === total) finalize();
                }
              });
            }
          });
        }).catch(err => {
          this.loader.close();  
          this.sending = false;
          this.confirmService.confirm({
            title: 'Erro na leitura dos arquivos',
            message: 'Falha ao converter arquivos para base64. Verifique os anexos e tente novamente.',
            error: true,
            icon: 'error',
            disableCancel: true
          });
          console.error('Erro ao converter arquivos para base64:', err);
        });
      },
      error: () => {
        this.loader.close();
        this.sending = false;
        this.confirmService.confirm({
          title: 'Falha na verificação',
          message: 'Falha ao verificar instância WhatsApp Evolution. Tente novamente ou contate o suporte.',
          error: true,
          disableCancel: true
        });
      }
    });
  }

  cancel() {
    this.dialogRef.close({ success: false, cancelled: true });
  }
}
